// function applyScript() {
//    console.log("Custom-bold");

//   var swatchElements = document.querySelectorAll('.bold_option_value_swatch span');

// // Loop through each swatch element
// swatchElements.forEach(function(swatchElement) {
//   // Get the background URL from the style attribute
//   var backgroundUrl = swatchElement.style.backgroundImage;

//   if (backgroundUrl) {
//     // Extract the URL from the background image value
//     var imageUrl = backgroundUrl.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');

//     // Create an img element
//     var imgElement = document.createElement('img');
//     imgElement.src = imageUrl;

//     // Find the nearest ".bold_option_swatch_title" and append the img directly
//     var titleElement = swatchElement.closest('.bold_option_value')?.querySelector('.bold_option_swatch_title');
//     if (titleElement) {
//       titleElement.appendChild(imgElement);
//     }
//   }
// });
// }
// function observeDOM() {
//   var observer = new MutationObserver(function(mutationsList) {
//     for (var mutation of mutationsList) {
//       if (mutation.type === 'childList' && mutation.target.classList.contains('bold_options_loaded')) {
//         applyScript();
//         // document.querySelectorAll(".bold_option_element input, .bold_option_element select").forEach(function(element) {
//         //   element.addEventListener('change', function() {
//         //     applyScript();
//         //   });
//         // });
//         observer.disconnect();
//         break;
//       }
//     }
//   });
//   observer.observe(document.body, {
//     childList: true,
//     subtree: true
//   });
// }
// document.addEventListener('DOMContentLoaded', function() {
//   observeDOM();
// });

const radioValueMap = {
	"Two": 2,
	"Three": 3,
	"Four": 4,
	"Five": 5,
	"Six": 6,
	"Seven": 7,
	"Eight": 8,
	"Nine": 9,
	"Ten": 10,
	"Eleven": 11,
	"Twelve": 12,
	"Thirteen": 13,
};
let selectedSwatchesCount = 0;
let swatchMax = 9999999999;

function applyScript() {
	console.log("Called");
	setTimeout(function () {
		selectedSwatchesCount = 0;

		// Get all elements with class ".bold_option_value"
		var optionElements = document.querySelectorAll('.bold_option_value');
		console.log("BOLD==>")
		// Loop through each option element
		optionElements.forEach(function (optionElement) {
			// Check if the option has a swatch
			var swatchElement = optionElement.querySelector('.bold_option_value_swatch span');
			if (swatchElement) {

				// Check if the option already has a "hover_image" span
				var existingHoverImage = optionElement.querySelector('.hover_image');
				if (existingHoverImage) {
					// Remove the existing "hover_image" span
					existingHoverImage.remove();
				}
				// Get the background URL from the style attribute
				var backgroundUrl = swatchElement.style.backgroundImage;
				// Extract the URL from the background image value
				var imageUrl = backgroundUrl.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');
				// Create a new span element with class "hover_image"
				var hoverImageElement = document.createElement('span');
				hoverImageElement.classList.add('hover_image');
				// Create an img element
				var imgElement = document.createElement('img');
				imgElement.src = imageUrl;
				if (imageUrl) {
					// Append the img element to the "hover_image" span
					hoverImageElement.innerHTML = "";
					hoverImageElement.appendChild(imgElement);
				} else {
					const colorElement = document.createElement("div");
					const color = swatchElement.getAttribute("style");
					colorElement.setAttribute("style", color + "aspect-ratio:1/1;");
					hoverImageElement.innerHTML = "";
					hoverImageElement.appendChild(colorElement);
				}
				// Append the "hover_image" span to the "bold_option_swatch_title" element
				var swatchTitleElement = optionElement.querySelector('.bold_option_value_title');
				swatchTitleElement.prepend(hoverImageElement);

				// if swatch max is reached, prevent selecting
				swatchElement.addEventListener("click", e => {
					if (selectedSwatchesCount >= swatchMax + 1 && !e.target.closest(".bold_swatch_selected")) {
						e.preventDefault();
						e.stopPropagation();
						e.stopImmediatePropagation();
						return;
					}
				});

				// see if swatch is selected and add it ot the total count
				const isSelected = swatchElement.closest(".bold_swatch_selected");
				if (isSelected) {
					selectedSwatchesCount++;
				}
			}

			// get checked radio value
			var selectedRadioElement = optionElement.querySelector('input[type="radio"]:checked');
			const currentSwatchMax = radioValueMap[selectedRadioElement?.value.trim()];
			if (selectedRadioElement && currentSwatchMax) {
				if (swatchMax !== currentSwatchMax) {
					swatchMax = currentSwatchMax;
					const selectedSwatchesList = document.querySelectorAll(".bold_option.bold_option_swatch ~ .bold_option.bold_option_swatch .bold_swatch_selected");
					selectedSwatchesList.forEach(swatch => swatch.click());
				}
			}
		});
	}, 500)

	// Size
	$('.bold_option_value').mouseover(function () {
		var x = $(this).position();
		// var right = $(window).width() - x.left - $(this).width();
		var parentWidth = $(this).parent().width(); // Get parent width instead of window width
		var right = parentWidth - x.left - $(this).width();

		// Remove all positioning classes first
		$(this).removeClass('tooltip-left-pos tooltip-right-pos tooltip-center-pos');

		if (x.left < 205) {
			$(this).addClass('tooltip-left-pos');
		} else if (right < 160) {
			$(this).addClass('tooltip-right-pos');
		} else {
			$(this).addClass('tooltip-center-pos');
		}
	});


	if ($(window).width() <= 768) {
		$('.bold_option_value').each(function () {
			var t = $(this).position();
			var i = $(window).width() - t.left - $(this).width();
			var o = t.left - i;
			if (o < 50 && o > -50) {
				$(this).addClass('tooltip-center-pos');
			} else if (t.left < i) {
				$(this).addClass('tooltip-left-pos');
			} else if (i < t.left) {
				$(this).addClass('tooltip-right-pos');
			}
		});
	}

}


function _observeDOM() {
	var observer = new MutationObserver(function (mutationsList) {
		for (var mutation of mutationsList) {
			if (mutation.type === 'childList' && mutation.target.classList.contains('bold_options_loaded')) {
				applyScript();
				document.querySelectorAll(".bold_option_element input, .bold_option_element select").forEach(function (element) {
					element.addEventListener('change', function () {
						applyScript();
					})
				})
				observer.disconnect();
				break;
			}
		}
	});
	observer.observe(document.body, {
		childList: true,
		subtree: true
	});
}

document.addEventListener('DOMContentLoaded', function () {
	_observeDOM();
});
